import { CallWithConfig } from './service-communicator'
import { OfficeInfo } from './dto/officeinfo.dto'
import { TicketInfo } from './dto/ticketinfo.dto'
import { ServiceInfo } from './dto/serviceinfo.dto'
import dayjs from 'dayjs'
import qs from 'qs'

export class NQC {
  constructor(baseurl)
  {
    //TODO: Ta reda på exakta anrop och fyll i informationen
    this.configs = {
      getAllOffices: () => ({
          method: 'get',
          url: '/api/offices',
          baseURL: baseurl,
          headers: {
            Authorization: '',
            Accept: 'application/json'
          },
          responseType: 'json'
      }),
      getAvailableQueues: () => ({
          method: 'get',
          url: '/api/queueinfo/servicetype',
          baseURL: baseurl,
          headers: {
            Authorization: 'bearer',
            Accept: 'application/json'
          },
          responseType: 'json'
      }),
      getSpecificQueueuInfo: serviceTypeID => ({
        method: 'get',
        url: '/api/queueinfo/servicetype/' + serviceTypeID,
        baseURL: baseurl,
        headers: {
          Authorization: 'bearer',
          Accept: 'application/json'
        },
        responseType: 'json'
    }),
      getTicketInfo: ticketNumber => ({
          method: 'get',
          url: '/api/office/getticketinfo/?ticketnumber=' + ticketNumber,
          baseURL: baseurl,
          headers: {
            Authorization: 'bearer',
            Accept: 'application/json'
          },
          responseType: 'json'
      }),
      cancelTicket: (workstationid) => ({
      }),
      getWaitingTicketList: (queuetype, unitnumber, unittype) => ({
        method: 'post', 
        url: '/api/office/GetWaitingTicketList',
        baseURL: baseurl,
        data: qs.stringify({
          QueueType: queuetype,
          UnitNumber: unitnumber,
          UnitType: unittype
        }),
        headers: {
          Authorization: 'bearer',
          Accept: 'application/json'
        },
        responseType: 'json'
      }),
      takeTicket: (servicetype, customertext, printerNumber, printerTextNumber) => ({
          method: 'post',
          url: '/api/office/ticket',
          baseURL: baseurl,
          data: JSON.stringify ({
            unitType: 1,
            unitNumber: servicetype,
            printerTextNumber: printerTextNumber,
            printerNumber: printerNumber,
            printerCopies: 0,
            logo: 1,
            delay: 0,
            customerText: customertext || "",
            icu: "",
            ticketText: []
          }),
          headers: {
            Authorization: 'bearer',
            Accept: 'application/json',
            'content-type': 'application/json'
          },
          responseType: 'json'
      }),
      setReminder: ticketID => { console.log('set reminder function not implemented'); }
    }
  }

  // Support function, it takes some time before the submitted ticket gets into the system
  async wait(delay) {
    return new Promise(resolve => setTimeout(resolve, delay));
  }
  
  async getAllOffices() {
    const result = await CallWithConfig(this.configs.getAllOffices());
    var listOfAllOffices = null;
    try 
    {
      listOfAllOffices = result.map(x => new OfficeInfo(x.name, x.guid, x.address.street, x.address.city, x.address.zipcode, x.address.latitude,x.address.longitude, null, x.adminInfo.phone))
    }
    catch
    {
      return null;
    }
    return listOfAllOffices;
  }

  async getAvailableQueuesForSelectedOffice(officeID, timeout) {
    const result = await CallWithConfig(this.configs.getAvailableQueues(), timeout);
    var listOfAllServiceTypes = null;
    try
    {
      listOfAllServiceTypes = result.map((x, i) => new ServiceInfo(x.serviceType.name, x.queues.main.waitingTickets, x.queues.main.longestWaitingTicketTime ? dayjs().diff(x.queues.main.longestWaitingTicketTime, "second") : 0, x.activeWorkstations, x.serviceType.id)); //det står både longestWaitingTimeMQ och longestWaitingTimeTicketMQ
    }
    catch
    {
      return null;
    }
    return listOfAllServiceTypes;
  }

  // TODO: Se över detta, kan bli tvungen att skapa en ny modell
  async getIndividualTicketInfo(ticketNumber) {
    var ticketResult;
    var ticket = null;
    ticketResult = await CallWithConfig(this.configs.getTicketInfo(ticketNumber)); // The source is incorrectly formated, needs an extra parse

    if (ticketResult && ticketResult.length > 0)
    {
      let alltickets;
      let peopleAhead = 0;
      alltickets = await CallWithConfig(this.configs.getWaitingTicketList(ticketResult[0].queueType, ticketResult[0].serviceType, 1));
      if (alltickets)
      {
        if (alltickets.length > 0)
        {
          // If we recieve a non-empty array but our number is not in the array then we have been precalled or missed an update.
          peopleAhead = alltickets.findIndex(x => x.turnNumber === ticketResult[0].ticket);
          if (peopleAhead < 0)
            peopleAhead = 0;
          }
        ticket = new TicketInfo(peopleAhead, ticketResult[0].ticket, ticketResult[0].cashier, ticketResult[0].ticket, dayjs(ticketResult[0].ticketTime).format('YYYY-MM-DD HH:mm'), ticketResult[0].endTime);
      }
    }
    return ticket;
  }

  async cancelTicket() {
    return true;
  }

  // branchID exists simply because Gala needs it, refactor later
  async grabATicket(queuedata, branchID, customertext, printerNumber, printerTextNumber) {
    const result = await CallWithConfig(this.configs.takeTicket(queuedata.queueID, customertext, printerNumber, printerTextNumber));
    let ticketNumber = null;
    if (result)
      ticketNumber = result.turnNumber;
    return ticketNumber;
  }
  async setReminder(ticketID) {
    const result = await CallWithConfig(this.configs.setReminder(ticketID));
  }
}


